import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=087ff9df&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/formats.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/pages/pages.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./MyPage.vue?vue&type=style&index=2&id=087ff9df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ff9df",
  null
  
)

export default component.exports